export default {
  similarProductDownloadTask:
    JSON.parse(localStorage.getItem('similarProductDownloadTask')) || {},
  similarProductUploadTask:
    JSON.parse(localStorage.getItem('similarProductUploadTask')) || {},
};
